import { useEffect } from 'react';
import { useRouteError } from 'react-router-dom';
import { isChunkError, reloadOnce } from 'utils/chunkReload';

// Shown when a page cannot load. A page missing after a release fixes itself with one automatic reload.
export default function RouteError() {
  const error = useRouteError();
  const stale = isChunkError(error);
  useEffect(() => { if (stale) reloadOnce(); }, [stale]);

  return (
    <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', background: '#0a0f16', color: '#e6edf5', fontFamily: 'system-ui, sans-serif', padding: 24, textAlign: 'center' }}>
      <div style={{ maxWidth: 440 }}>
        <div style={{ fontSize: 44, marginBottom: 8 }}>{stale ? '↻' : '!'}</div>
        <h1 style={{ fontSize: 24, margin: '0 0 10px' }}>{stale ? 'A new version is available' : 'Something went wrong'}</h1>
        <p style={{ color: '#9aa9ba', lineHeight: 1.6, margin: '0 0 22px' }}>
          {stale ? 'FuzzScan was just updated. Reloading to get the latest version.' : 'This page could not be shown. Reloading usually fixes it. If it keeps happening, tell your administrator.'}
        </p>
        <button type="button" onClick={() => window.location.reload()} style={{ height: 44, padding: '0 24px', borderRadius: 10, border: 0, background: '#22c55e', color: '#06220f', fontWeight: 700, fontSize: 15, cursor: 'pointer' }}>Reload the page</button>
      </div>
    </div>
  );
}
